import React, {useState, useEffect, useContext} from 'react';
import {createLabels} from '@dazn/fe-labels';
import * as FeLabelsReact from '@dazn/fe-labels-react';

import Markdown from 'markdown-to-jsx';

const markdownTransformer = (labelProps: any, value: string) => {
    if (labelProps.markdown) {
        return <Markdown>{value}</Markdown>;
    }
    return value;
};

const labelsConfig = {
    resourceStrings: window?.dazn?.resourceStringsData?.Strings,
    transformers: [markdownTransformer]
};

function FeLabelsProvider({children}: {children: React.ReactNode}) {
    const [labels, setLabels] = useState(createLabels(labelsConfig));

    useEffect(() => {
        setLabels(
            createLabels({
                ...labelsConfig
            })
        );
    }, []);

    return (
        <FeLabelsReact.LabelsProvider
            value={{
                labels
            }}
        >
            {children}
        </FeLabelsReact.LabelsProvider>
    );
}

function useFeLabelsState() {
    const context = useContext(FeLabelsReact.LabelsContext);
    if (typeof context === 'undefined') {
        throw new Error(
            'useFeLabelsState must be used within a FeLabelsReact.LabelsContext'
        );
    }
    return context;
}

export {FeLabelsProvider, useFeLabelsState};
